<template>
  <div class="main-top-space">
    <main class="book-detail">
      <app-loading v-if="isLoading"></app-loading>
      <section class="book-review" v-else>
        <section v-for="review in bookReviews" class="review-main-card">
          <div class="book-review-stars">
            <app-star :rate="review.rating"></app-star>
            <div class="book-review-stars__caption">
              <p>{{review.create_at}} {{review.name_reviewer}}</p>
            </div>
          </div>
          <p class="book-review__sentence">{{review.message}}</p>
        </section>
      </section>
    </main>
    <div class="pc-on pc-review-btn-area">
      <router-link :to="{ name: 'bookReviewAdd' }" class="btn-square">レビューする</router-link>
    </div>
  </div>
</template>

<script>
  import Star from '../smallParts/Star.vue';
  import Loading from '../common/Loading.vue';

  export default {
    title: 'レビュー - abceed',
    headerTitle: 'レビュー',
    description: '',
    keywords: '',
    headerType: 'review',
    components: {
      appStar: Star,
      appLoading: Loading
    },
    data() {
      return {
        bookReviews: [],
      }
    },
    beforeCreate() {
      this.$store.dispatch("changeLoadingCondition", true);
    },
    created() {
      this.$http.get('webstore/book/detail?id_book=' + this.$route.params.id)
        .then(res => {
          return res.json();
        }, err => {
          return err.json();
        }).then(data => {
          this.bookReviews = data.detail.review_list;
          this.makeHeaderTitle(this.bookReviews.length);
          this.$store.dispatch("changeLoadingCondition", false);
        }).catch(() => {
          this.$store.dispatch("changeLoadingCondition", false);
        });
    },
    methods: {
      makeHeaderTitle(reviewAmount) {
        this.$store.dispatch("changeHeaderTitle", `レビュー (${reviewAmount})`);
      }
    },
    computed: {
      isLoading() {
        return this.$store.getters.isLoading;
      }
    }
  }
</script>

<style scoped lang="scss">
  .review-main-card {
    border-top: 1px solid #f9f9f9;
    padding-top: 12px;
    &:first-of-type {
      border-top: none;
    }
  }
  .book-review {
    padding: 0 15px 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/books/BookReview.vue